const routes = [


	//---- "Projects" module ----
	{
		path: '/module.projects',
		name: "module.projects-index",
		component: () => import("/module.projects/index.vue"),
		meta: { layout: "primary", module: "projects", parentRouteName: "", pageTitle: "Projects" }
	},
	{
		path: '/module.projects/setup',
		name: "module.projects-setup",
		component: () => import("/module.projects/setup.vue"),
		meta: { layout: "primary", module: "projects", parentRouteName: "module.projects-index", pageTitle: "Projects > Set up a project" }
	},
	{
		path: '/module.projects/:id',
		name: "module.projects-detail",
		component: () => import("/module.projects/project-detail.vue"),
		meta: { layout: "primary", module: "projects", parentRouteName: "module.projects-index", pageTitle: "Projects > {projectName}" }
	},

]


export default routes;
